<footer id="footer">
    <span class="logo-slingmax">SLINGMAX rigging solution</span>
</footer>
